import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'nl',
  months: [
    'januari',
    'februari',
    'maart',
    'april',
    'mei',
    'juni',
    'juli',
    'augustus',
    'september',
    'oktober',
    'november',
    'december',
  ],
  monthsShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
  weekdays: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
  weekdaysMin: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
  weekdaysShort: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
  formats: {
    LT: 'HH.mm',
    LTS: 'HH.mm:ss',
    lt: 'HH.mm',
    lts: 'HH.mm:ss',
    L: 'DD-MM-YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY, HH.mm',
    'LLL-Y': 'D MMMM, HH.mm',
    LLLL: 'dddd D MMMM YYYY, HH.mm',
    'LLLL-Y': 'dddd D MMMM, HH.mm',
    l: 'D-M-YYYY',
    'l-Y': 'D-M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY, H.mm',
    'lll-Y': 'D MMM, H.mm',
    llll: 'ddd. D MMM YYYY, H.mm',
    'llll-Y': 'ddd. D MMM, H.mm',
    'll-Y+w': 'ddd. D MMM',
    'LT+to': 'HH.mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY, H.mm ([GMT]Z)',
  },
  meridiem: { am: 'a.m.', pm: 'p.m.', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s jaar geleden', other: '%s jaar geleden' },
    M: { one: '%s maand geleden', other: '%s maanden geleden' },
    w: { one: '%s week geleden', other: '%s weken geleden' },
    d: { one: '%s dag geleden', other: '%s dgn geleden' },
    h: { one: '%s uur geleden', other: '%s uur geleden' },
    m: { one: '%s min. geleden', other: '%s min. geleden' },
    s: { one: '%s sec. geleden', other: '%s sec. geleden' },
  },
  future: {
    y: { one: 'over %s jaar', other: 'over %s jaar' },
    M: { one: 'over %s maand', other: 'over %s maanden' },
    w: { one: 'over %s week', other: 'over %s weken' },
    d: { one: 'over %s dag', other: 'over %s dgn' },
    h: { one: 'over %s uur', other: 'over %s uur' },
    m: { one: 'over %s min.', other: 'over %s min.' },
    s: { one: 'over %s sec.', other: 'over %s sec.' },
  },
  pastLong: {
    y: { one: '%s jaar geleden', other: '%s jaar geleden' },
    M: { one: '%s maand geleden', other: '%s maanden geleden' },
    w: { one: '%s week geleden', other: '%s weken geleden' },
    d: { one: '%s dag geleden', other: '%s dagen geleden' },
    h: { one: '%s uur geleden', other: '%s uur geleden' },
    m: { one: '%s minuut geleden', other: '%s minuten geleden' },
    s: { one: '%s seconde geleden', other: '%s seconden geleden' },
  },
  futureLong: {
    y: { one: 'over %s jaar', other: 'over %s jaar' },
    M: { one: 'over %s maand', other: 'over %s maanden' },
    w: { one: 'over %s week', other: 'over %s weken' },
    d: { one: 'over %s dag', other: 'over %s dagen' },
    h: { one: 'over %s uur', other: 'over %s uur' },
    m: { one: 'over %s minuut', other: 'over %s minuten' },
    s: { one: 'over %s seconde', other: 'over %s seconden' },
  },
  abbr: {
    y: { one: '%s jr', other: '%s jr' },
    M: { one: '%s m', other: '%s m' },
    w: { one: '%s w', other: '%s w' },
    d: { one: '%s d', other: '%s d' },
    h: { one: '%s u', other: '%s u' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%s s', other: '%s s' },
  },
  full: {
    y: { one: '%s jaar', other: '%s jaar' },
    M: { one: '%s maand', other: '%s maanden' },
    w: { one: '%s week', other: '%s weken' },
    d: { one: '%s dag', other: '%s dagen' },
    h: { one: '%s uur', other: '%s uur' },
    m: { one: '%s minuut', other: '%s minuten' },
    s: { one: '%s seconde', other: '%s seconden' },
  },
  justNow: 'zojuist',
  yesterday: 'Gisteren',
  today: 'Vandaag',
  tomorrow: 'Morgen',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd. D MMM YYYY', end: 'ddd. D MMM YYYY' },
    'Y-1': { start: 'ddd D MMM', end: 'ddd D MMM YYYY' },
    M: { start: 'ddd. D MMM', end: 'ddd. D MMM' },
    D: { start: 'ddd. D MMM', end: 'ddd. D MMM' },
    yt: { start: 'D MMM YYYY, HH.mm', end: 'D MMM YYYY, HH.mm' },
    mt: { start: 'D MMM, HH.mm', end: 'D MMM, HH.mm' },
    dt: { start: 'D MMM, HH.mm', end: 'D MMM, HH.mm' },
    t: { start: 'HH.mm', end: 'HH.mm' },
    'yt+to': { start: 'D MMM YYYY, HH.mm', end: 'D MMM YYYY, HH.mm' },
    'mt+to': { start: 'D MMM, HH.mm', end: 'D MMM, HH.mm' },
    'dt+to': { start: 'D MMM, HH.mm', end: 'D MMM, HH.mm' },
    't+to': { start: 'HH.mm', end: 'HH.mm' },
  },
};
const localeName: LocaleName = 'nl';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `[${n}${n === 1 || n === 8 || n >= 20 ? 'ste' : 'de'}]`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'a.m.' : 'AM';
    } else {
      return isLowerCase ? 'p.m.' : 'PM';
    }
  },
};
